export default __webpack_public_path__ + "static/header_oldschool-51eebe055c28a88475d0eae735f61736.svg";